import React from 'react';
import ReactDOM from 'react-dom';
import App from './lesson17/App';



ReactDOM.render(<App/>, document.getElementById('root'));
